import { render, staticRenderFns } from "./UserNotificationSettings.vue?vue&type=template&id=46ffe581&scoped=true"
import script from "./UserNotificationSettings.vue?vue&type=script&lang=ts"
export * from "./UserNotificationSettings.vue?vue&type=script&lang=ts"
import style0 from "./UserNotificationSettings.vue?vue&type=style&index=0&id=46ffe581&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ffe581",
  null
  
)

export default component.exports